import {Injectable} from '@angular/core';
import {BasicList, EvolutionTimeForm, EvolutionVolumeForm, OptionsList, OptionsListForm, RewardListForm, Rules, RulesForm} from '../models/rules';
import * as moment from 'moment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RulesMapperService {

  constructor() {}

  formToDb(data: RulesForm , rulesStor: Rules): Rules {
    return {
      id: data.id ? data.id : null,
      contractID: data.contractID ? data.contractID : null,
      start: data.start,
      end: data.end,
      po: data.billing.po,
      billingProductID: data.billing.billingProduct.id,
      priceFixed: data.price.priceFixed ? data.price.priceFixed : null,
      priceConnectionOn: data.priceConnection.priceConnectionOn ? data.priceConnection.priceConnectionOn : null,
      priceConnectionOff: data.priceConnection.priceConnectionOff ? data.priceConnection.priceConnectionOff : null,
      license: data.license.license.id,
      licenseValue: data.license.licenseValue,
      setupFee: data.fee.setupFee,
      communicationFee: data.fee.communicationFee,
      maintenanceFee: data.fee.maintenanceFee,
      adminFee: data.fee.adminFee,
      adminFeePercent: data.fee.adminFeePercent,
      rewards: data.rewards.rewardList ? this.rewardFormToDb(data , rulesStor) : null,
      options: data.options.optionList ? this.optionFormToDb(data , rulesStor) : null,
      priceEvolutionTimes: data.evolutionTime.evolutionTimeList ? this.evolutionTimeFormToDb(data , rulesStor) : null,
      priceEvolutionVolumes: data.evolutionVolume.PriceVolumeList ? this.evolutionVolumeFormToDb(data , rulesStor) : null,
    }
  }


  dbToForm(data: Rules): RulesForm {
    return    {
      billing: { po: data.po , billingProduct: { id:  data.billingProductID , name: null}},
      fee: {
      setupFee: data.setupFee,
      communicationFee: data.communicationFee,
      maintenanceFee: data.maintenanceFee,
      adminFee:  data.adminFee,
      adminFeePercent:  data.adminFeePercent
    },
      price: {
      priceFixed: data.priceFixed,
    },
      priceConnection: {
        priceConnectionOn: data.priceConnectionOn,
        priceConnectionOff: data.priceConnectionOff,
      },
      id: data.id,
      contractID:  data.contractID  ,
      start:  data.start,
      end:  data.end,
      license: {
      license: {id : data.license} ,
      licenseValue:  data.licenseValue,
    },
      misc: {
      created: data.created,
      createdBy: data.createdBy,
      updated: data.updated,
      updatedBy: data.updatedBy,
      deleted: data.deleted,
    },
      rewards : {
      rewardList : data.rewards ? this.rewardDbToForm(data) : []  ,
    },
      options : {
        optionList : data.options ? this.optionDbToForm(data) : this.createOptions()  ,
      },
      evolutionTime : {
        evolutionTimeList :  data.priceEvolutionTimes ? this.evolutionTimeDbToFrom(data)  : []   ,
      },
      evolutionVolume: {
        PriceVolumeList : data.priceEvolutionVolumes ? this.evolutionVolumeDbToFrom(data) : []   ,
      }
    }
  }
  optionFormToDb(data: RulesForm , rule: Rules): OptionsList[] {
    const option = [];
    // tslint:disable-next-line:no-any
    let optionValue: any;
    let index;
    data.options.optionList.forEach( optionForm => {

      if (optionForm && optionForm.value && optionForm.key) {
        index = _.findIndex(option, function (o: BasicList): boolean {
          return o.key === optionForm.key;
        });

        if (index === -1) {
          option.push({
            id: optionForm.id,
            key: optionForm.key,
            value: {
              variance: optionForm.variance,
              price: optionForm.value,
            },
            deleted: optionForm.deleted,
          });
        }
      }
    });
    if (rule && rule.options.length > 0 ) {
      rule.options.forEach(optionsStore => {
        if (optionsStore) {
          index = _.findIndex(option, function (o: BasicList): boolean {
            return o.id === optionsStore.id;
          });
          if (index === -1) {
            // @ts-ignore
            optionValue = JSON.parse(optionsStore.value);
            option.push({
              id: optionsStore.id,
              key: optionsStore.key,
              value: {
                variance: optionValue.variance,
                price: optionValue.price,
              } ,
              deleted: moment().format('YYYY-MM-DD[T]HH:mm:ss'),
            });
          }
        }
      })
    }
    return option ;
  }
  evolutionTimeFormToDb(data: RulesForm , rule: Rules): BasicList[] {
    const evolutionTime = [];
    let index;
    data.evolutionTime.evolutionTimeList.forEach( evolutionTimeForm => {
      if (evolutionTimeForm && evolutionTimeForm.start && evolutionTimeForm.start) {
        evolutionTime.push({
          id: evolutionTimeForm.id,
          key: evolutionTimeForm.start + '|' + evolutionTimeForm.end,
          value: evolutionTimeForm.price,
          deleted: evolutionTimeForm.deleted,
        });
      }
    });
    if (rule && rule.priceEvolutionTimes.length > 0) {
    rule.priceEvolutionTimes.forEach( priceEvTStore => {
      if (priceEvTStore) {
        index = _.findIndex(evolutionTime, function(o: BasicList): boolean { return o.id === priceEvTStore.id; });
        if (index === -1) {
          evolutionTime.push({
            id: priceEvTStore.id,
            key: priceEvTStore.key.split('|')[0] + '|' + priceEvTStore.key.split('|')[1],
            value: JSON.parse(priceEvTStore.value),
            deleted: moment().format('YYYY-MM-DD[T]HH:mm:ss'),
          });
        }
      }
    })
    }
    return evolutionTime ;
  }
  evolutionVolumeFormToDb(data: RulesForm , rule: Rules): BasicList[] {
    const evolutionVolume = [];
    let index;
    data.evolutionVolume.PriceVolumeList.forEach( evolutionVolumeForm => {
      if (evolutionVolumeForm && evolutionVolumeForm.min && evolutionVolumeForm.price) {

        evolutionVolume.push({
          id: evolutionVolumeForm.id,
          key: evolutionVolumeForm.min + '|' + evolutionVolumeForm.max,
          value: evolutionVolumeForm.price,
          deleted: evolutionVolumeForm.deleted,
        });
      }
    })
    if (rule && rule.priceEvolutionVolumes.length > 0) {
      rule.priceEvolutionVolumes.forEach(priceEvVStore => {
        if (priceEvVStore) {
          index = _.findIndex(evolutionVolume, function (o: BasicList): boolean {
            return o.id === priceEvVStore.id;
          });
          if (index === -1) {
            evolutionVolume.push({
              id: priceEvVStore.id,
              key: priceEvVStore.key.split('|')[0] + '|' + priceEvVStore.key.split('|')[1],
              price: JSON.parse(priceEvVStore.value),
              deleted: moment().format('YYYY-MM-DD[T]HH:mm:ss'),
            });
          }
        }
      })
    }
    return evolutionVolume ;
  }
  optionDbToForm(data: Rules): OptionsListForm[] {
    const option = this.createOptions();
    // tslint:disable-next-line:no-any
    let optionValue: any ;
    if (data.options) {
      data.options.forEach( optionForm => {
        // @ts-ignore
        optionValue = JSON.parse(optionForm.value);
        if (optionForm) {
          if (optionForm.key === 'musicService' ) {
            option[0] = {
              id: optionForm.id,
              key: optionForm.key,
              value: optionValue.price,
              variance: optionValue.variance,
              deleted: optionForm.deleted,
            };
          }
          if (optionForm.key === 'projectManagement' ) {
            option[1] = {
              id: optionForm.id,
              key: optionForm.key,
              value: optionValue.price,
              variance: optionValue.variance,
              deleted: optionForm.deleted,
            };
          }
          if (optionForm.key === 'softwareService' ) {
            option[2] = {
              id: optionForm.id,
              key: optionForm.key,
              value: optionValue.price,
              variance: optionValue.variance,
              deleted: optionForm.deleted,
            };
          }
          if (optionForm.key === 'materialLocation' ) {
            option[3] = {
              id: optionForm.id,
              key: optionForm.key,
              value: optionValue.price,
              variance: optionValue.variance,
              deleted: optionForm.deleted,
            };
          }
          if (optionForm.key === 'braketRental' ) {
            option[4] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === 'monitorRental' ) {
            option[5] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === 'onlineMaintenance' ) {
            option[6] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === 'remoteManagement' ) {
            option[7] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === 'SIMDataService' ) {
            option[8] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === 'SSLCertificateRenewal' ) {
            option[9] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === 'widgetService' ) {
            option[10] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === 'audioPlayerRental' ) {
            option[11] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === 'videoPlayerRental' ) {
            option[12] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
          if (optionForm.key === '4GRouterManagementLicense' ) {
            option[13] = { id: optionForm.id, key: optionForm.key, value: optionValue.price, variance: optionValue.variance, deleted: optionForm.deleted };
          }
        }
      })
    }
    return option ;
  }

  // tslint:disable-next-line:no-any
  createOptions(): any [] {

     const options = [];
     options.push({
       id: '',
       key: 'musicService',
       value: '',
       variance: '',
     });
     options.push({
       id: '',
       key: 'projectManagement',
       value: '',
       variance: '',
     });
     options.push({
       id: '',
       key: 'softwareService',
       value: '',
       variance: '',
     });
     options.push({
      id: '',
      key: 'materialLocation',
      value: '',
      variance: '',
    });
     options.push({id: '', key: 'braketRental', value: '', variance: '' });
     options.push({id: '', key: 'monitorRental', value: '', variance: '' });
     options.push({id: '', key: 'onlineMaintenance', value: '', variance: '' });
     options.push({id: '', key: 'remoteManagement', value: '', variance: '' });
     options.push({id: '', key: 'SIMDataService', value: '', variance: '' });
     options.push({id: '', key: 'SSLCertificateRenewal', value: '', variance: '' });
     options.push({id: '', key: 'widgetService', value: '', variance: '' });
     options.push({id: '', key: 'audioPlayerRental', value: '', variance: '' });
     options.push({id: '', key: 'videoPlayerRental', value: '', variance: '' });
     options.push({id: '', key: '4GRouterManagementLicense', value: '', variance: '' });
     return options;
  }

  rewardFormToDb(data: RulesForm , rule: Rules): BasicList[] {
    const reward = [];
    let index ;
    data.rewards.rewardList.forEach( rewardForm => {
      if (rewardForm && rewardForm.name && rewardForm.value) {
        reward.push({
          id: rewardForm.id,
          key: rewardForm.name,
          value: rewardForm.value,
          deleted: rewardForm.deleted,
        });
      }
    });
    if (rule && rule.rewards.length > 0 ) {
      rule.rewards.forEach( rewardStore => {
      if (rewardStore) {
        index = _.findIndex(reward, function(o: BasicList): boolean { return o.id === rewardStore.id; });
        if (index === -1) {
          reward.push({
            id: rewardStore.id,
            key: rewardStore.key,
            value:  JSON.parse(rewardStore.value),
            deleted: moment().format('YYYY-MM-DD[T]HH:mm:ss'),
          });
        }
      }
    })
    }
    return reward ;
  }

  rewardDbToForm(data: Rules): RewardListForm[] {
    const reward = [];
    if (data.rewards) {
      data.rewards.forEach( rewardForm => {
        if (rewardForm) {
          reward.push({
            id: rewardForm.id,
            name: rewardForm.key,
            value: JSON.parse(rewardForm.value),
            deleted: rewardForm.deleted,
          });
        }
      })
    }
    return reward;
  }
  evolutionTimeDbToFrom(data: Rules): EvolutionTimeForm[] {
    const evolutionTime = [];
    if (data.priceEvolutionTimes) {
      data.priceEvolutionTimes.forEach( form => {
        if (form) {
          evolutionTime.push({
            id: form.id,
            start: form.key.split('|')[0] ? form.key.split('|')[0]  : '',
            end: form.key.split('|')[1] ? form.key.split('|')[1] : '',
            price: JSON.parse(form.value),
            deleted: form.deleted,
          });
        }
      })
    }
    return evolutionTime;
  }
  evolutionVolumeDbToFrom(data: Rules): EvolutionVolumeForm[] {
    const evolutionVolume = [];
    if (data.priceEvolutionVolumes) {
      data.priceEvolutionVolumes.forEach( volumeForm => {
        if (volumeForm) {
          evolutionVolume.push({
            id: volumeForm.id,
            min: volumeForm.key.split('|')[0],
            max: volumeForm.key.split('|')[1],
            price: JSON.parse(volumeForm.value),
            deleted: volumeForm.deleted,
          });
        }
      })
    }
    return evolutionVolume;
  }

}

